import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SingleTestimonialFive from '../../components/Testimonial/SingleTestimonialFive';
import SectionTitle from '../../components/SectionTitle';
import { Pagination } from 'swiper/modules';

import shapeImg1 from '../../assets/img/slider/shape-1.png';
import shapeImg2 from '../../assets/img/slider/shape-2.png';
import shapeImg3 from '../../assets/img/slider/shape-3.png';
import testimonialImg1 from '../../assets/img/blog/blog-1.jpg';
import testimonialImg2 from '../../assets/img/blog/blog-2.jpg';

const Testimonial = () => {
  const sliderOption = {
    pagination: {
      el: '.testimonial-slider-dots',
      clickable: true,
    },
    loop: true,
    slidesPerView: '2',
    spaceBetween: 30,
    breakpoints: {
      1200: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
  };

  return (
    <div className="testimonial__area testimonial__plr blue-bg p-relative">
      <div className="testimonial__shape-1 d-none d-lg-block">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="testimonial__shape-2">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="testimonial__shape-3">
        <img src={shapeImg3} alt="" />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <SectionTitle
              sectionClass="testimonial-2__section-title text-center pb-40 section-title-fixed-width"
              subTitleClass="section-subtitle section-white-bg title-anim wow animate__fadeInUp"
              titleClass="section-title text-white title-anim wow animate__fadeInUp"
              subTitle="Client Testimonial"
              Title="We Are the Best Software Company Manage.."
            />
          </div>
        </div>
        <div className="testimonial-2__slider-wrapper">
          <div className="swiper-container testimonial-2__active">
            <Swiper
              modules={[Pagination]}
              {...sliderOption}
              className="swiper-wrapper"
            >
              <SwiperSlide className="swiper-slide">
                <SingleTestimonialFive
                  Image={testimonialImg1}
                  Title="Sasan Barson"
                />
              </SwiperSlide>
              <SwiperSlide className="swiper-slide">
                <SingleTestimonialFive
                  Image={testimonialImg2}
                  Title="Marata Barson"
                />
              </SwiperSlide>
              <SwiperSlide className="swiper-slide">
                <SingleTestimonialFive
                  Image={testimonialImg1}
                  Title="Sasan Barson"
                />
              </SwiperSlide>
              <SwiperSlide className="swiper-slide">
                <SingleTestimonialFive
                  Image={testimonialImg2}
                  Title="Marata Barson"
                />
              </SwiperSlide>
            </Swiper>
            <div className="testimonial-slider-dots z-index"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
